'use strict';
angular.module('impactx.controlstructure')

    .controller('ControlInputCtrl', ['$scope', '$mdDialog', '$filter', '$timeout', 'TranslationService',
        function ($scope, $mdDialog, $filter, $timeout, TranslationService) {
        $scope.showedOneTime = false;
        $scope.searchResults = 50;

        this.getAutoCompleteValues = function(searchText) {

            var results = [];

            if (!searchText) {
                return $timeout(function() {
                    if ($scope.showedOneTime)
                    {
                        results = $scope.controls;
                    }
                    else
                    {
                        results = $scope.controls.slice(0,  $scope.searchResults);
                        if ($scope.controls.length > $scope.searchResults)
                        {
                            results.push({id: -1, value: TranslationService.get("moreResults")});
                        }
                        $scope.showedOneTime = true;
                    }
                    return results;
                });
            }
            else {
                results =  $filter('filter')($scope.controls, searchText);
            }
            return results;
        };

        this.loadMore = function(event, item)
        {
            if (item.id < 0)
            {
                event.stopPropagation();
            }
        };

        $scope.searchText = "";
        $scope.enableNew = false;
        $scope.enableEdit = false;

        $scope.showControlDialog = function (event, selected)
        {
            $mdDialog.show({
                templateUrl: 'shared/control/controldialog.html',
                controller: function ControlDialogController($scope, $mdDialog, data, trns, dataGen)
                {
                   // ToDo!
                },
                targetEvent: event,
                clickOutsideToClose: false,
                hasBackdrop: true,
                disableParentScroll: true,
                locals: {
                    data: selected,
                    trns: {label: $scope.labelTitle}
                }
            });
        }

        this.getItemText = function(item) {
            return item.value + ' ' + item.name;
        };

        this.getPlaceholder = function () {
            return TranslationService.get("selectAnything").replace('^0', $scope.labelTitle);
        };

    }
    ])


    .directive('appControlInput', [function ()
    {
        return {
            scope: {
                controls: '=',
                labelTitle: '=',
                selectionId: '=',
                selected: '=',
                trns: '=',
                enableNew: '@',           // determines if "new"-button will be displayed, default: false
                enableEdit: '@'           // determines if "edit"-button will be displayed, default: false
            },
            controller: 'ControlInputCtrl',
            controllerAs: 'ctrl',
            restrict: 'E',
            templateUrl: 'shared/control/appControlInput.html',
            transclude: true
        };
    }
    ]);